<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>自选职业管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15" style="display: flex; justify-content: space-between">
        <router-link :to="'/users/occupation/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加职业
          </el-button>
        </router-link>
        <router-link :to="'/users/occupation-questionnaire'">
          <el-button type="primary"
                     size="small">推送列表
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90" />
        <el-table-column prop="name"
                         label="职业名称"
                         min-width="120" />
        <el-table-column prop="adminname"
                         label="创建人"
                         min-width="120" />
        <el-table-column prop="user_cnt"
                         label="零工数量"
                         min-width="120" />
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190" />
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/users/occupation/${scope.row.id}/users`">
                <el-button size="mini"
                           type="success">查看该职业用户
                </el-button>
              </router-link>
              <router-link :to="`/users/occupation/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOccupationTable', params)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/occupation/pages/OccupationTable.vue